// extracted by mini-css-extract-plugin
export var fadeIn = "_mq-1";
export var modalContent = "_mq-3";
export var overlay = "_mq-0";
export var popoverContent = "_mq-2";
export var results = "_mq-5";
export var searchInputWrapper = "_mq-4";